"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.number.is-integer");require("core-js/modules/es6.function.name");



























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, name: '', searchData: { name: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', password: '', birthDate: '', mobile: '', sex: '' }, rules: { name: [{ required: true, message: '请输入病房号', trigger: 'blur' }], password: [{ required: true, message: '请输入密码', trigger: 'blur' }], mobile: [{ required: true, validator: this.handleCheckMobile, trigger: 'blur' }], sex: [{ required: true, message: '请输入性别', trigger: 'blur' }], birthDate: [{ required: false, message: '请输入出生日期', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'name', label: '姓名', isShow: true }, { prop: 'mobile', label: '电话', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, val) {return val === 1 ? '男' : '女';}, isShow: true }, { prop: 'password', label: '登录密码', isShow: true }, { prop: 'birthDate', formatter: _formatter.dateSimpleFormatter, label: '出生日期', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/medical/doctor', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.name = '新增';this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, updateMenu: function updateMenu(item) {// 修改操作
      this.name = '修改';var self = this;self.newadd = true;self.addData = {
        id: item.id,
        name: item.name,
        password: item.password,
        birthDate: item.birthDate,
        mobile: item.mobile,
        sex: item.sex + '' };

    },
    handleLookPatient: function handleLookPatient(item) {
      console.log(item);
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/medical/doctor', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/medical/doctor?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        age: '',
        complaint: '',
        birthDate: '',
        mobile: '',
        sex: '' };

    },
    handleCheckAge: function handleCheckAge(rule, value, callback) {
      if (!value) {
        return callback(new Error('年龄不能为空'));
      }
      setTimeout(function () {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 1) {
            callback(new Error('必须年满1岁'));
          } else {
            callback();
          }
        }
      }, 500);
    },
    handleCheckMobile: function handleCheckMobile(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      setTimeout(function () {
        var regx = /^[0-9]*$/;
        if (!regx.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }, 500);
    },
    handleToPatientPage: function handleToPatientPage(doctorId) {
      var self = this;
      self.$router.push('doctorPatient/' + doctorId);
    } } };exports.default = _default;